document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper === "undefined") return;

  const sections = Array.from(document.querySelectorAll(".image-text-slider-section"));

  sections.forEach((section) => {
    const sliderRoot = section.querySelector("[data-image-text-swiper]");
    const textItems = Array.from(section.querySelectorAll(".image-text-item"));
    const slides = Array.from(section.querySelectorAll(".image-text-slide"));
    const nextEl = section.querySelector(".swiper-button-next");
    const prevEl = section.querySelector(".swiper-button-prev");
    const paginationEl = section.querySelector(".swiper-pagination");

    if (!sliderRoot || !textItems.length || !slides.length) return;

    const mobileStep = section.querySelector("[data-mobile-step]");
    const mobileStepTitle = mobileStep ? mobileStep.querySelector(".image-text-mobile-step-title") : null;
    const mobileStepDesc = mobileStep ? mobileStep.querySelector(".image-text-mobile-step-description") : null;

    function setActiveUI(index) {
      textItems.forEach((item) => {
        const itemIndex = Number(item.getAttribute("data-index"));
        item.classList.toggle("active", itemIndex === index);
      });

      slides.forEach((slide) => {
        const slideIndex = Number(slide.getAttribute("data-index"));
        slide.classList.toggle("active", slideIndex === index);
      });

      var activeItem = textItems.find(function (item) {
        return Number(item.getAttribute("data-index")) === index;
      });
      if (activeItem && mobileStepTitle && mobileStepDesc) {
        var title = activeItem.querySelector(".image-text-item-title");
        var desc = activeItem.querySelector(".image-text-item-description");
        mobileStepTitle.textContent = title ? title.textContent : "";
        mobileStepDesc.textContent = desc ? desc.textContent : "";
      }
    }

    const hasLoop = slides.length > 2;
    const swiper = new Swiper(sliderRoot, {
      slidesPerView: 3,
      centeredSlides: true,
      loop: hasLoop,
      watchOverflow: false,
      initialSlide: slides.length > 1 ? 1 : 0,
      spaceBetween: 0,
      speed: 500,
      pagination: {
        el: paginationEl,
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        }
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl
      },
      breakpoints: {
        0: {
          slidesPerView: 3
        },
        768: {
          slidesPerView: 3
        },
        1024: {
          slidesPerView: 3,
        }
      },
      on: {
        init: function () {
          setActiveUI(this.realIndex);
        },
        slideChange: function () {
          setActiveUI(this.realIndex);
        }
      }
    });

    textItems.forEach((item) => {
      item.addEventListener("click", function () {
        const targetIndex = Number(item.getAttribute("data-index"));
        if (Number.isNaN(targetIndex)) return;

        if (hasLoop) {
          swiper.slideToLoop(targetIndex);
        } else {
          swiper.slideTo(targetIndex);
        }

        setActiveUI(targetIndex);
      });
    });
  });
});
